import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "sf-heading sf-category-title sf-menu__title"
}
const _hoisted_2 = {
  key: 0,
  class: "sf-menu__cards"
}
const _hoisted_3 = { class: "sf-menu__card-media" }
const _hoisted_4 = ["src", "alt"]
const _hoisted_5 = { class: "sf-menu__card-body" }
const _hoisted_6 = { class: "sf-menu__card-name only-2-lines" }
const _hoisted_7 = { class: "sf-menu__card-count" }
const _hoisted_8 = {
  key: 1,
  class: "flex flex-col"
}
const _hoisted_9 = {
  key: 2,
  class: "flex flex-col"
}
const _hoisted_10 = ["data-sf-category"]
const _hoisted_11 = { class: "sf-heading sf-category-title sf-menu__category-title" }
const _hoisted_12 = {
  key: 0,
  class: "sf-menu__count"
}
const _hoisted_13 = {
  key: 2,
  class: "flex flex-col justify-center items-center sm:pt-14 m-auto",
  style: {"padding-bottom":"7rem"}
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "252",
  height: "166",
  viewBox: "0 0 252 166",
  fill: "none"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M218.84 48.2183V58.5663C238.937 45.3962 235.303 43.5147 250.611 62.543C252.92 65.4507 252.193 69.5984 249.071 71.4798L218.84 90.0377V145.54C218.84 156.401 209.689 165.082 198.828 165.082H53.1446C42.2835 165.082 33.1328 156.401 33.1328 145.54V90.0377L2.90145 71.4798C-0.220032 69.5984 -0.904194 65.3651 1.40485 62.543C16.713 43.9851 12.0949 44.7975 33.1328 58.5663C33.1328 50.5701 31.7218 44.541 37.3661 42.4885C57.164 34.193 77.2185 28.8053 97.5295 26.2824C91.3293 6.1424 124.853 -6.98494 145.592 6.27069C152.989 10.9743 157.009 18.6711 154.358 26.6245C174.284 29.3184 194.381 34.5779 214.607 42.4885C217.044 43.2154 218.84 45.5245 218.84 48.2183ZM110.315 25.0851L141.444 25.2989C149.611 16.7469 125.965 7.93833 112.838 16.3193C108.904 18.7994 107.493 21.9209 110.315 25.0851ZM55.1971 46.5935H194.595C148.842 36.2027 100.95 35.7324 55.1971 46.5935Z",
    fill: "#E0E0E0"
  })
], -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("h5", { class: "font-medium text-lg pt-2" }, "Nenhum produto disponível", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("p", { class: "sf-menu__muted text-center" }, "Volte mais tarde", -1)
const _hoisted_17 = [
  _hoisted_14,
  _hoisted_15,
  _hoisted_16
]
const _hoisted_18 = { key: 3 }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("h5", { class: "mb-6 h-6 w-30 animate-pulse sf-skeleton" }, null, -1)
const _hoisted_20 = { class: "grid grid-cols-12 gap-4 md:gap-8 animate-pulse" }
const _hoisted_21 = /*#__PURE__*/_createStaticVNode("<div class=\"w-full sf-radius h-40 sf-skeleton\"></div><h5 class=\"font-bold my-2 sf-skeleton w-full\"><span class=\"opacity-0\">skeleton</span></h5><p class=\"font-bold sf-skeleton w-15\"><span class=\"opacity-0\">skeleton</span></p>", 3)
const _hoisted_24 = [
  _hoisted_21
]

import { computed, nextTick, onMounted, ref, watch } from 'vue'
import { restaurant, categories } from '@/global/state/GlobalState'
import { MenuSection, ProductCardVariant, storefront, storefrontTemplate, storefrontLayout } from '@/global/state/StorefrontState'
import StoreProductGrid from '../StoreProductGrid.vue'
import CategoryNavBar from '../CategoryNavBar.vue'
import { getCategoryImage } from '../storefrontUtils'
import { scrollToElement, useScrollSpy, useStickyTop } from '../useCategoryNav'

/* global defineProps, defineEmits */

export default /*#__PURE__*/_defineComponent({
  __name: 'MenuSection',
  props: {
    section: {}
  },
  emits: ['open-product'],
  setup(__props: any, { emit: __emit }) {


const emit = __emit

const template = storefrontTemplate
const layout = storefrontLayout

const rootEl = ref<HTMLElement | null>(null)
const anchorEl = ref<HTMLElement | null>(null)
const navBar = ref<any>(null)

const visibleCategories = computed<any[]>(() => (categories.value || []).filter((c: any) => c?.products?.length))

/** sections: chips only when the sticky bar is enabled; delivery: always (and always sticky); tabs: always. */
const showNav = computed(() => {
  if (layout.value === 'delivery' || layout.value === 'tabs') return true
  return layout.value === 'sections' && storefront.value.settings.stickyCategoryNav && visibleCategories.value.length > 1
})
const navSticky = computed(() => layout.value === 'delivery' || storefront.value.settings.stickyCategoryNav)
const spyEnabled = computed(() => showNav.value && (layout.value === 'sections' || layout.value === 'delivery'))

/** Delivery: product rows, or 2-column cards when columnsMobile is '2' (keeps the dark card on the dark template). */
const deliveryCardVariant = computed<ProductCardVariant>(() => {
  if (storefront.value.settings.columnsMobile !== '2') return 'classic'
  return template.value === 'dark' ? 'dark' : 'grid'
})

const stickyTop = useStickyTop()
const navHeight = () => (navBar.value?.$el as HTMLElement | undefined)?.offsetHeight ?? 0
const spy = useScrollSpy(rootEl, () => stickyTop.value + navHeight() + 12)

function refreshSpy() {
  nextTick(() => {
    if (spyEnabled.value) spy.observe()
    else spy.disconnect()
  })
}
onMounted(refreshSpy)
watch([visibleCategories, spyEnabled, layout, stickyTop], refreshSpy)

// Abas: primeira categoria por padrão; mantém a seleção quando os produtos recarregam
const selectedId = ref<string | null>(null)
watch(visibleCategories, (list) => {
  if (!list.some((c: any) => String(c.id) === selectedId.value)) selectedId.value = list.length ? String(list[0].id) : null
}, { immediate: true })
const selectedCategory = computed(() => visibleCategories.value.find((c: any) => String(c.id) === selectedId.value) ?? null)

function onNavSelect(id: string) {
  if (layout.value === 'tabs') {
    selectedId.value = id
    // bar stuck (page scrolled past the start of the menu): bring the top of the panel back into view
    const anchor = anchorEl.value
    if (anchor && navSticky.value && anchor.getBoundingClientRect().top < stickyTop.value) scrollToElement(anchor)
    return
  }
  const block = rootEl.value?.querySelector<HTMLElement>(`[data-sf-category="${CSS.escape(id)}"]`)
  if (!block) return
  spy.lock(id)
  scrollToElement(block, (navSticky.value ? navHeight() : 0) + 8)
}

const initialOf = (name?: string) => (name || '?').trim().charAt(0).toUpperCase()
const countLabel = (category: any) => {
  const n = category?.products?.length ?? 0
  return `${n} ${n === 1 ? 'item' : 'itens'}`
}

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", {
    ref_key: "rootEl",
    ref: rootEl,
    class: _normalizeClass(["sf-menu home__categories", [`sf-menu--${_unref(template)}`, `sf-menu--layout-${_unref(layout)}`]])
  }, [
    (_ctx.section.settings.title)
      ? (_openBlock(), _createElementBlock("h4", _hoisted_1, _toDisplayString(_ctx.section.settings.title), 1))
      : _createCommentVNode("", true),
    (visibleCategories.value.length)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          (_unref(layout) === 'categories')
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(visibleCategories.value, (category, index) => {
                  return (_openBlock(), _createBlock(_component_RouterLink, {
                    key: category.id,
                    to: { name: 'categories.show', params: { id: category.id } },
                    class: "sf-menu__card group"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_3, [
                        (_unref(getCategoryImage)(category))
                          ? (_openBlock(), _createElementBlock("img", {
                              key: 0,
                              src: _unref(getCategoryImage)(category) as string,
                              alt: category.name,
                              loading: "lazy",
                              class: "transition-transform duration-300 group-hover:scale-105"
                            }, null, 8, _hoisted_4))
                          : (_openBlock(), _createElementBlock("div", {
                              key: 1,
                              class: _normalizeClass(["sf-menu__card-initial", { 'is-alt': index % 2 === 1 }])
                            }, _toDisplayString(initialOf(category.name)), 3))
                      ]),
                      _createElementVNode("div", _hoisted_5, [
                        _createElementVNode("p", _hoisted_6, _toDisplayString(category.name), 1),
                        _createElementVNode("p", _hoisted_7, _toDisplayString(countLabel(category)), 1)
                      ])
                    ]),
                    _: 2
                  }, 1032, ["to"]))
                }), 128))
              ]))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createElementVNode("div", {
                  ref_key: "anchorEl",
                  ref: anchorEl,
                  class: "sf-menu__anchor",
                  "aria-hidden": "true"
                }, null, 512),
                (showNav.value)
                  ? (_openBlock(), _createBlock(CategoryNavBar, {
                      key: 0,
                      ref_key: "navBar",
                      ref: navBar,
                      items: visibleCategories.value,
                      "active-id": _unref(layout) === 'tabs' ? selectedId.value : _unref(spy).activeId.value,
                      variant: _unref(layout) === 'sections' ? 'chips' : 'underline',
                      sticky: navSticky.value,
                      top: _unref(stickyTop),
                      onSelect: onNavSelect
                    }, null, 8, ["items", "active-id", "variant", "sticky", "top"]))
                  : _createCommentVNode("", true),
                (_unref(layout) === 'tabs')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                      (selectedCategory.value)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: selectedCategory.value.id,
                            class: "pb-10 home__categories__item sf-menu__tab-panel",
                            role: "tabpanel"
                          }, [
                            _createVNode(StoreProductGrid, {
                              products: selectedCategory.value.products,
                              onSelect: _cache[0] || (_cache[0] = (p) => emit('open-product', p))
                            }, null, 8, ["products"])
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_9, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(visibleCategories.value, (category) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: category.id,
                          class: "pb-10 home__categories__item",
                          "data-sf-category": String(category.id)
                        }, [
                          _createElementVNode("h5", _hoisted_11, [
                            _createTextVNode(_toDisplayString(category.name) + " ", 1),
                            (_unref(layout) === 'delivery')
                              ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(countLabel(category)), 1))
                              : _createCommentVNode("", true)
                          ]),
                          _createVNode(StoreProductGrid, {
                            products: category.products,
                            variant: _unref(layout) === 'delivery' ? deliveryCardVariant.value : undefined,
                            onSelect: _cache[1] || (_cache[1] = (p) => emit('open-product', p))
                          }, null, 8, ["products", "variant"])
                        ], 8, _hoisted_10))
                      }), 128))
                    ]))
              ], 64))
        ], 64))
      : _createCommentVNode("", true),
    (!_unref(categories)?.some((c) => c.products?.length) && _unref(restaurant)?.id)
      ? (_openBlock(), _createElementBlock("div", _hoisted_13, _hoisted_17))
      : _createCommentVNode("", true),
    (!_unref(categories))
      ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
          _hoisted_19,
          _createElementVNode("div", _hoisted_20, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList([1,2,3,4], (item) => {
              return _createElementVNode("div", {
                class: "col-span-6 md:col-span-4 lg:col-span-3 cursor-pointer",
                key: item
              }, _hoisted_24)
            }), 64))
          ])
        ]))
      : _createCommentVNode("", true)
  ], 2))
}
}

})